enum PageType {
  Home = 'home',
  Product = 'product',
  Collection = 'collection',
  Collections = 'collections',
  Vendors = 'vendors',
  Page = 'page',
  Cart = 'cart',
}

export function getPageType(): PageType | undefined {
  const convermaxPage = window.Convermax?.page;
  if (convermaxPage) {
    switch (convermaxPage.pageType) {
      case 'index':
        return PageType.Home;
      case 'collection':
        return convermaxPage.currentVendor // vendor collection page (/collections/vendors?q=)
          ? PageType.Vendors
          : PageType.Collection;
      case 'list-collections':
        return PageType.Collections;
      default:
        return convermaxPage.pageType as PageType;
    }
  }

  return window.ShopifyAnalytics?.meta?.page?.pageType as PageType | undefined;
}

export function getProductId(): number | undefined {
  return window.Convermax?.page?.productId ?? window.ShopifyAnalytics?.meta?.product?.id;
}

export function getCollectionId(): number | undefined {
  if (window.Convermax?.page?.collectionId) {
    return window.Convermax.page.collectionId;
  }

  if (getPageType() === PageType.Collection) {
    return window.ShopifyAnalytics?.meta?.page?.resourceId;
  }
}

export function getPageId(): number | undefined {
  if (window.Convermax?.page?.pageId) {
    return window.Convermax.page.pageId;
  }

  if (getPageType() === PageType.Page) {
    return window.ShopifyAnalytics?.meta?.page?.resourceId;
  }
}

export function getCustomerId(): number | undefined {
  return (
    window.Convermax?.customerId ??
    window.ShopifyAnalytics?.meta?.page?.customerId ??
    window.meta?.page?.customerId ??
    window.__st?.cid
  );
}
